export const FETCH_ITEM_COUNT = 18;
export const IMAGE_COMPRESSED_QUALITY = 0.8;
export const IMAGE_COMPRESSED_WIDTH = 1920;
export const IMAGE_COMPRESSED_HEIGHT = 1080;

export const EDIT_STATUS = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
};

export const JOURNAL_PUBLISH_STATUS = {
  PUBLISHED: 1,
  DRAFT: -1,
};

export const PUBLIC_LEVEL = {
  PRIVATE: 0,
  BY_LINK: 1,
  PUBLIC: 2,
};
